<template>
  <b-button variant="primary" type="button" class="float-right" @click.prevent="onClick"><font-awesome-icon icon="pencil-alt"/> Edit</b-button>
</template>
<script>
  export default {
    methods: {
      onClick () {
        window.location.href = '#' + this.$route.path + '/edit'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttons/Edit.vue